<template>
  <transition name="slide-fade" >

    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Certifications help you broaden your skill-sets and improve your marketability
            </p>
          </div>
        </div>
        <div class="uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
         <!--   <div class="uk-alert-primary uk-padding-small uk-margin-top uk-border-rounded"  uk-alert>

              <p class="uk-text-center">Click the degree your interested in for more information.</p>
            </div>-->
            <div class="uk-overflow-auto">
              <table class="uk-table  uk-table-divider ">
                <thead>
                <tr>
                  <th class="uk-visible@l"> <h3 style="color: rgb(197,179,88) !important;" class="uk-heading-bullet specHeading">List of Certifications</h3></th>
                  <th class="uk-hidden@l uk-heading-bullet specHeading" style="color: rgb(197,179,88) !important;" > List of Certifications</th>
                  <th class="uk-table-shrink">Certificate</th>
                  <th class="uk-table-shrink">Diploma</th>
                  <!--<th class="uk-table-shrink">Undergraduate</th>-->
                  <th class="uk-table-shrink">Graduate</th>
<!--
                  <th class="uk-table-shrink"></th>
-->
                </tr>
                </thead>
                <tbody class="">

                <tr>
                  <td>
                    <span class="">Application Development</span>
                  </td>

                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td></td>

                  <td>
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Education </span>
                  </td>
                  <td></td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>


                  <td>
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <!--
                                    <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
                  -->
                </tr>
                <tr>
                  <td>
                    <span class="">Tropical Agriculture </span>
                  </td>
                  <td></td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>


                  <td>

                  </td>
                  <!--
                                    <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
                  -->
                </tr>

                <tr>
                  <td>
                    <span class="">Information Security</span>
                  </td>

                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td >
                  <td ></td>

                  <td>
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Information Technology</span>
                  </td>

                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>

                  </td>

                  <td>
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Network Administration</span>
                  </td>

                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td></td>

                  <td>
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Technology Development</span>
                  </td>

                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td></td>

                  <td>
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Conflict Resolution & Management</span>
                  </td>
                  <td  class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>

                  </td>

                  <td>

                  </td>
                  <!--
                                    <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
                  -->
                </tr>
                <tr>
                  <td>
                    <span class="">Crime & Security Management </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Crisis, Trauma & Grief Counselling </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Techniques of Photography </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Public Relations & Communication</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Performance and Pedagogy  </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>

               <tr>
                  <td>
                    <span class="">Business Communication </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Digital & Social Media Marketing </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Principles of Accounting & Finance </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Investment and Portfolio Management</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Family Life Education</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>

               <tr>
                  <td>
                    <span class="">Logistics & Supply Management</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Project Management</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Small Business Management</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">SDA Teacher Certification</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>

               <tr>
                  <td>
                    <span class="">Sales, Marketing & Branding</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Special Education </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Social Media Strategist </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Supervisory Management  </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Tax and Taxation  </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Telephone Hotline Counselling  </span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>

               <tr>
                  <td>
                    <span class="">Customer Relations</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Events Planning & Management</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Hotel Operations Management</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="">Occupational Health & Safety</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="">Grant & Research Writing</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>

               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CompTia - </span> <span class="uk-text-small"> A+</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CompTia - </span><span class="uk-text-small"> Linux</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>
                  <td></td>
                  <!--<td></td>
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CompTia - </span><span class="uk-text-small"> Network+</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text  uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CompTia - </span><span class="uk-text-small"> Project+</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CompTia - </span><span class="uk-text-small"> Security+</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">Microsoft - </span><span class="uk-text-small"> 70-410: Installing and Configuring Windows Server 2012</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">Microsoft - </span><span class="uk-text-small"> 70-411: Administering Windows Server 2012</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">Microsoft - </span><span class="uk-text-small">70-412: Configuring Advanced Windows Server 2012 Services</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">Microsoft - </span><span class="uk-text-small">70-740: Installation, Storage, and Compute with Windows Server 2016</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span> <span class="uk-text-small"> Desktop Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span> <span class="uk-text-small"> PC Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span><span class="uk-text-small"> Network Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span> <span class="uk-text-small"> Security Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span><span class="uk-text-small"> Linux Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span><span class="uk-text-small"> Routing Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
               <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">TestOut - </span><span class="uk-text-small"> Switching Pro</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span><span class="uk-text-small"> Internet Business Associate</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span> <span class="uk-text-small"> Site Development Associate</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span><span class="uk-text-small"> Network Technology Associate</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
<!--
                  <td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>
-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span><span class="uk-text-small"> Web Security Associate</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
                  <!--<td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span><span class="uk-text-small"> Advanced HTML5 and CSS3 Specialist</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
                  <!--<td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span><span class="uk-text-small"> User Interface Designer</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
                  <!--<td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>-->
                </tr>
                <tr>
                  <td>
                    <span class="uk-text-muted  uk-text-bold">CIW - </span><span class="uk-text-small"> Database Design Specialist</span>
                  </td>
                  <td class="uk-text-center">
                    <span class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">

                  </td>

                  <td></td>
                  <!--<td><a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-text uk-text-small uk-text-muted" style="font-size: smaller;">Apply</a></td>-->
                </tr>


                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
      <!--<div class="uk-child-width-1-1" uk-grid>
        <div class="uk-padding uk-background-secondary uk-light">
          <div class="uk-container uk-container-small uk-padding">
            <p class="uk-text-center uk-text-lead uk-text-large">
              Certifications help you broaden your skill-sets and improve your marketability
            </p>
          </div>
        </div>


        <div class="uk-padding uk-margin-remove-top ">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Professional Development Certifications</h1>
          </div>
        </div>

        <div class="uk-padding uk-margin-remove-top ">
          <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
                <h2 class="uk-heading-bullet specHeading">Behavioural and Social Sciences</h2>

                <div class="uk-child-width-1-2@m" uk-grid>
                  <div class="uk-padding">
                    <img src="../../../assets/behaviour.png" alt="">
                  </div>
                  <div class="uk-padding">
                    <ul class="uk-list">
                      <li><h5 class="uk-heading-bullet">Conflict Resolution & Management</h5></li>
                      <li><h5 class="uk-heading-bullet">Crime & Security Management </h5></li>
                      <li><h5 class="uk-heading-bullet">Crisis, Trauma & Grief Counselling </h5></li>

                    </ul>
                    <div class="uk-width-1-1">
                      <p class="uk-text-small uk-text-muted">
                        Course Duration Range from: 8 - 12 weeks <br>
                        Price Range from: $25, 000 - $35, 000 JMD
                      </p>
                    </div>
                    <div class="uk-align-right">
                      <a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                    </div>
                  </div>
                </div>

              </div>



            </div>
          </div>
        </div>

        <div class="uk-padding uk-margin-remove-top uk-background-muted ">
          <div class="uk-container uk-container-small">

            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
                <h2 class="uk-heading-bullet specHeading">Communication Studies</h2>

                <div class="uk-child-width-1-2@m" uk-grid>
                  <div class="uk-padding">
                    <img src="../../../assets/communication.png" alt="">
                  </div>
                  <div class="uk-padding">
                    <ul class="uk-list">
                      <li><h5 class="uk-heading-bullet">Techniques of Photography </h5></li>
                      <li><h5 class="uk-heading-bullet">Public Speaking </h5></li>


                    </ul>
                    <div class="uk-width-1-1">
                      <p class="uk-text-small uk-text-muted">
                        Course Duration Range from: 10 weeks <br>
                        Price Range: $20, 000 - $25, 000 JMD
                      </p>
                    </div>
                    <div class="uk-align-right">
                      <a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                    </div>
                  </div>




                </div>
              </div>



            </div>
          </div>
        </div>


        <div class="uk-padding uk-margin-remove-top ">
          <div class="uk-container uk-container-small">

            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
                <h2 class="uk-heading-bullet specHeading">Business Management</h2>

                <div class="uk-child-width-1-2@m" uk-grid>
                  <div class="uk-padding">
                    <img src="../../../assets/business.jpg" alt="">
                  </div>
                  <div class="uk-padding">
                    <ul class="uk-list">
                      <li><h5 class="uk-heading-bullet">Business Communication & Writing </h5></li>
                      <li><h5 class="uk-heading-bullet">Digital Marketing</h5></li>
                      <li><h5 class="uk-heading-bullet">Introductory Principles of Accounting & Finance </h5></li>
                      <li><h5 class="uk-heading-bullet">Investment and Portfolio Management</h5></li>
                      <li><h5 class="uk-heading-bullet">Logistics & Supply Management</h5></li>
                      <li><h5 class="uk-heading-bullet">Project Management <br> <span class="uk-text-small uk-text-muted" style="padding-left: 15px;">(PMI Curriculum – Professional Certification)</span></h5></li>
                      <li><h5 class="uk-heading-bullet">Small Business Management</h5></li>
                      <li><h5 class="uk-heading-bullet">Sales & Marketing</h5></li>
                      <li><h5 class="uk-heading-bullet">Social Media Strategist <br> <span class="uk-text-small uk-text-muted" style="padding-left: 15px;">US$160 Self Study, Instructor Led US$200</span></h5></li>
                      <li><h5 class="uk-heading-bullet">Supervisory Management </h5></li>
                      <li><h5 class="uk-heading-bullet">Tax and Taxation </h5></li>

                    </ul>
                    <div class="uk-width-1-1">
                      <p class="uk-text-small uk-text-muted">
                        Course Duration Range from: 6 - 15 weeks <br>
                        Price Range: $20, 000 - $90, 000 JMD
                      </p>
                    </div>
                    <div class="uk-align-right">
                      <a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                    </div>
                  </div>




                </div>
              </div>



            </div>
          </div>
        </div>

        <div class="uk-padding uk-margin-remove-top uk-background-muted ">
          <div class="uk-container uk-container-small">

            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
                <h2 class="uk-heading-bullet specHeading">Hospitality and Tourism Management</h2>

                <div class="uk-child-width-1-2@m" uk-grid>
                  <div class="uk-padding">
                    <img src="../../../assets/hospitality.png" alt="">
                  </div>
                  <div class="uk-padding">
                    <ul class="uk-list">
                      <li><h5 class="uk-heading-bullet">Customer Relations</h5></li>
                      <li><h5 class="uk-heading-bullet">Events Planning  </h5></li>
                      <li><h5 class="uk-heading-bullet">Introduction to Hotel Operations Management </h5></li>
                      <li><h5 class="uk-heading-bullet">Introduction to Occupational Health & Safety </h5></li>

                    </ul>
                    <div class="uk-width-1-1">
                      <p class="uk-text-small uk-text-muted">
                        Course Duration Range from: 6 - 13 weeks <br>
                        Price Range: $15, 000 - $60, 000 JMD
                      </p>
                    </div>
                    <div class="uk-align-right">
                      <a href="http://online.ncu.edu.jm/mod/page/view.php?id=10609" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                    </div>
                  </div>




                </div>
              </div>



            </div>
          </div>
        </div>



        <div class="uk-padding uk-margin-remove-top ">
          <div class="uk-container uk-container-small">

            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
              <h2 class="uk-heading-bullet specHeading">Computer Science (Self Study)</h2>

                <div class="uk-child-width-1-2@m" uk-grid>
                  <div class="uk-padding">
                    <img src="../../../assets/comptia.png" alt="">
                  </div>
                  <div class="uk-padding">
                    <ul class="uk-list">
                      <li><h5 class="uk-heading-bullet">A+</h5></li>
                      <li><h5 class="uk-heading-bullet">Linux+</h5></li>
                      <li><h5 class="uk-heading-bullet">Network+</h5></li>
                      <li><h5 class="uk-heading-bullet">Project+</h5></li>
                      <li><h5 class="uk-heading-bullet">Security+</h5></li>

                    </ul>
                      <div class="uk-align-right">
                        <a href="http://cis.ncu.edu.jm/register.aspx" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                      </div>
                  </div>




                </div>
              </div>



            </div>
          </div>
        </div>

        <div class="uk-padding uk-margin-remove-top uk-background-muted">
          <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-2@m" uk-grid>

              <div class="uk-padding">
                <img src="../../../assets/microsoft_logo.png" alt="">
              </div>
              <div class="uk-padding">
                <ul class="uk-list">
                  <li><h5 class="uk-heading-bullet">70-410: Installing and Configuring Windows Server 2012</h5></li>
                  <li><h5 class="uk-heading-bullet">70-411: Administering Windows Server 2012</h5></li>
                  <li><h5 class="uk-heading-bullet">70-412: Configuring Advanced Windows Server 2012 Services</h5></li>
                  <li><h5 class="uk-heading-bullet">70-740: Installation, Storage, and Compute with Windows Server 2016</h5></li>

                </ul>
                <div class="uk-align-right">
                  <a href="http://cis.ncu.edu.jm/register.aspx" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="uk-padding uk-margin-remove-top ">
          <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-2@m" uk-grid>


              <div class="uk-padding">
                <img src="../../../assets/TestOut.png" alt="">
              </div>
              <div class="uk-padding">
                <ul class="uk-list">
                  <li><h5 class="uk-heading-bullet">Desktop Pro</h5></li>
                  <li><h5 class="uk-heading-bullet">PC Pro</h5></li>
                  <li><h5 class="uk-heading-bullet">Network Pro</h5></li>
                  <li><h5 class="uk-heading-bullet">Security Pro</h5></li>
                  <li><h5 class="uk-heading-bullet">Linux Pro</h5></li>
                  <li><h5 class="uk-heading-bullet">Routing Pro</h5></li>
                  <li><h5 class="uk-heading-bullet">Switching Pro</h5></li>

                </ul>
                <div class="uk-align-right">
                  <a href="http://cis.ncu.edu.jm/register.aspx" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="uk-padding uk-margin-remove-top uk-background-muted">
          <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-2@m" uk-grid>

              <div class="uk-padding">
                <img src="../../../assets/ciw.png" alt="">
              </div>
              <div class="uk-padding">
                <ul class="uk-list">
                  <li><h5 class="uk-heading-bullet">Internet Business Associate</h5></li>
                  <li><h5 class="uk-heading-bullet">Site Development Associate</h5></li>
                  <li><h5 class="uk-heading-bullet"> Network Technology Associate</h5></li>
                  <li><h5 class="uk-heading-bullet">Web Security Associate</h5></li>
                  <li><h5 class="uk-heading-bullet">Advanced HTML5 and CSS3 Specialist</h5></li>
                  <li><h5 class="uk-heading-bullet">User Interface Designer</h5></li>
                  <li><h5 class="uk-heading-bullet">Database Design Specialist</h5></li>

                </ul>
                <div class="uk-align-right">
                  <a href="http://cis.ncu.edu.jm/register.aspx" target="_blank" class="uk-button uk-button-secondary">Register Now</a>
                </div>
              </div>


            </div>
          </div>
        </div>


      </div>-->
    </div>
  </transition>
</template>

<script>
    export default {
        name: "certificateprograms",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Certificates and Diplomas',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Certificates and Diplomas offered by Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
            text-align:center !important;
        }


        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
